import { render, staticRenderFns } from "./summaryStatistics.vue?vue&type=template&id=370f3601&scoped=true"
import script from "./summaryStatistics.vue?vue&type=script&lang=js"
export * from "./summaryStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370f3601",
  null
  
)

export default component.exports